import { State } from 'src/redux';

export const getSysInfo = (state: State) => state.sysInfo;
